import { createContext, useContext, useState, useEffect } from 'react';
import { useUser } from './UserContext';

const SelectedChatbotContext = createContext();

export const SelectedChatbotProvider = ({ children }) => {
  const [selectedChatbot, setSelectedChatbot] = useState(null);
  const [availableAssistants, setAvailableAssistants] = useState([]);
  const { user } = useUser();

  const clearChatbotData = () => {
    setSelectedChatbot(null);
    setAvailableAssistants([]);
  };

  // Efecto para manejar los cambios en el usuario y sus productos
  useEffect(() => {
    if (!user) {
      setAvailableAssistants([]);
      setSelectedChatbot(null);
      sessionStorage.removeItem('lastSelectedChatbot');
      return;
    }

    let assistants = [];
    
    // Transformamos los productos en asistentes
    if (user.products && user.products.length > 0) {
      // Mantener el orden original recibido en user.products
      assistants = user.products.map(product => ({
        assistant: product.code,
        name: product.name,
        parentcode: product.parentcode,
        organization_tree: product.organization_tree,
        level_tree: product.level_tree
      }));
      setAvailableAssistants(assistants);

      // Intentar recuperar el último chatbot seleccionado del sessionStorage
      const lastSelectedChatbot = sessionStorage.getItem('lastSelectedChatbot');
      
      // Si hay un chatbot guardado y todavía está disponible, usarlo
      if (lastSelectedChatbot && assistants.find(a => a.assistant === lastSelectedChatbot)) {
        setSelectedChatbot(lastSelectedChatbot);
      }
      // Si no hay chatbot seleccionado o el actual ya no existe, seleccionamos el primero
      else if (!selectedChatbot || !assistants.find(a => a.assistant === selectedChatbot)) {
        const newSelectedChatbot = assistants[0].assistant;
        setSelectedChatbot(newSelectedChatbot);
        sessionStorage.setItem('lastSelectedChatbot', newSelectedChatbot);
      }
    } else {
      setAvailableAssistants([]);
      setSelectedChatbot(null);
      sessionStorage.removeItem('lastSelectedChatbot');
    }
  }, [user, user?.products]); // Dependemos específicamente de user.products también

  // Efecto para persistir el chatbot seleccionado
  useEffect(() => {
    if (selectedChatbot) {
      sessionStorage.setItem('lastSelectedChatbot', selectedChatbot);
    }
  }, [selectedChatbot]);

  return (
    <SelectedChatbotContext.Provider value={{ 
      selectedChatbot, 
      setSelectedChatbot, 
      availableAssistants,
      clearChatbotData 
    }}>
      {children}
    </SelectedChatbotContext.Provider>
  );
};

export const useSelectedChatbot = () => {
  const context = useContext(SelectedChatbotContext);
  if (!context) {
    throw new Error('useSelectedChatbot debe usarse dentro de un SelectedChatbotProvider');
  }
  return context;
};
